import { CustomFieldsEditModels } from './models/custom-fields-edit.models';
import { CustomFieldsAddModels } from './models/custom-fields-add.models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ListService {

  constructor(private http: HttpClient) { }

  //Behavior Subject for CustomField
  private customField = new BehaviorSubject('');

  getCustomField(): Observable<any> {
    return this.customField.asObservable();
  }

  setCustomField(field) {
    this.customField.next(field);
  }

  getAllModules() {
    return this.http.get<any>(`${environment.configUrl}LionO360_Object`)
  }

  getAllCustomFields(id) {
    return this.http.get<any>(`${environment.configUrl}Configuration/CustomAttributes?objectId=${id}`)
      .toPromise()
      .then(res => res);
  }

  getAllCustomFieldTypes(id) {
    return this.http.get<any>(`${environment.configUrl}Configuration/FormControls?objectId=${id}`)
      .toPromise()
      .then(res => res);
  }

  deletCustomField(id, objectId) {
    return this.http.delete<any>(`${environment.configUrl}Configuration/CustomAttribute/${id}?objectId=${objectId}`)
      .toPromise()
      .then(res => res);
  }

  addCustomFieldsConfiguration(obj) {
    return this.http.post<any>(`${environment.configUrl}Configuration/CustomAttribute`, obj)
      .toPromise()
      .then(res => res);
  }

  getAllLevels() {
    return this.http.get<any>(`${environment.configUrl}Level`)
      .toPromise()
      .then(res => res);
  }

  getAllTypes() {
    return this.http.get<any>(`${environment.appOrgUrl}Type`)
      .toPromise()
      .then(res => res);
  }

  getAllCategories() {
    return this.http.get<any>(`${environment.appOrgUrl}Category`)
      .toPromise()
      .then(res => res);
  }

  getCustomFieldById(id, objectId) {
    return this.http.get<any>(`${environment.configUrl}Configuration/CustomAttributes/${id}?objectId=${objectId}`)
      .toPromise()
      .then(res => res);
  }

  updateCustomFieldsConfiguration(obj) {
    return this.http.put<any>(`${environment.configUrl}Configuration/CustomAttribute`, obj)
      .toPromise()
      .then(res => res);
  }

  getConfigurationByModuleName(name) {
    return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`)
  }

  createCustomField(fieldInfo: CustomFieldsAddModels){
    return this.http.post<any>( `${environment.configUrlV2}/Field/CustomAttribute`, fieldInfo);
  }

  updateCustomField(fieldInfo: CustomFieldsEditModels){
    return this.http.put<any>( `${environment.configUrlV2}/Field/CustomAttribute`, fieldInfo);
  }

  deleteCustomField(moduleId: number, customAttributeId: number){
    return this.http.delete<any>( `${environment.configUrlV2}/Field/CustomAttribute/Module/${moduleId}/CustomAttributeId/${customAttributeId}`);
  }
}
